import { emailServices } from 'src/services/notification/email/email.service'

export const handleRegenerateNotification = async (
  record: any,
  cardId: string,
  setLoadingRegenerateNotificationModal: React.Dispatch<React.SetStateAction<boolean>>,
  setOpenRegenerateNotificationtModal: React.Dispatch<React.SetStateAction<boolean>>,
  notify: any,
  setCardLoading: any,
  getEmailHistory: any
) => {
  try {
    setLoadingRegenerateNotificationModal(true)
    if (record) {
      const response = await emailServices.sendEmail(record)
      if (response === 200) {
        notify('ra.notification.regenerate_notification_to_success', { type: 'success' })
        return
      }
    }
    notify('ra.notification.regenerate_notification_to_error', {
      type: 'error',
    })
  } catch (error) {
    notify('ra.notification.regenerate_notification_to_error', {
      type: 'error',
    })
  } finally {
    setLoadingRegenerateNotificationModal(false)
    setOpenRegenerateNotificationtModal(false)
    getEmailHistory(record?.hash_item)
    setCardLoading(cardId, false)
  }
}
